import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppDispatch } from "../../redux/store";
import { updateError } from "../../redux/slices/meta";
import { updatePlayerId } from "../../redux/slices/menu";
import { useSmartNavigate } from "../useSmartNavigate";
import { useUser } from "../../components/menu/auth/is_loggedin";
import RoomAPI from "../../RoomAPI";
import { GameSettings, RoomMeta, PlayerDetails, RoomMode } from "../../types";

interface UseGameCreationReturn {
  createGame: (
    settings: GameSettings,
    playerDetails: PlayerDetails,
    roomMode?: RoomMode
  ) => Promise<void>;
  isSubmitting: boolean;
  error: string | null;
  clearError: () => void;
}

const useGameCreation = (): UseGameCreationReturn => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const navigate = useSmartNavigate();
  const dispatch = useAppDispatch();
  const user = useUser();
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  const createGame = async (
    settings: GameSettings,
    playerDetails: PlayerDetails,
    roomMode?: RoomMode
  ) => {
    if (!playerDetails) {
      alert("WHERE IS YOUR PLAYER?");
      return;
    }

    try {
      setIsSubmitting(true);
      setError(null);

      const roomMeta: RoomMeta = roomMode ? { mode: roomMode } : {};

      let token;
      if (isAuthenticated) {
        token = await getAccessTokenSilently();
      }

      const room = await RoomAPI.CreateRoom(
        settings,
        roomMeta,
        playerDetails,
        user?.auth0Id,
        token
      ).catch((reason) => {
        dispatch(updateError(reason.response.data));
        setError(reason.response.data);
        setIsSubmitting(false);
        throw reason;
      });

      if (room && room.host) {
        dispatch(
          updatePlayerId({
            ...room.host,
            room_id: room.id,
            room_code: room.code,
          })
        );

        if (room.host.secret) {
          localStorage.setItem("playerSecret", room.host.secret);
        }

        localStorage.setItem("gameSettings", JSON.stringify(settings));
        if (room.code) {
          localStorage.setItem("roomCode", room.code);
        }

        navigate(`/game/${room.code}`);
      }
    } catch (err) {
      const errorMessage = "something bad happened: " + err;
      alert(errorMessage);
      setError(errorMessage);
      setIsSubmitting(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    createGame,
    isSubmitting,
    error,
    clearError,
  };
};

export default useGameCreation;
;
